import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appGetAllSanstha } from '../../store/sanstha'
import { sansthaExportColumns } from '../../config/exportColumns/sansthaExportColumns'
import { useState } from 'react'

function Sanstha() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Sanstha</div>

					<div className="d-flex gap-2">
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllSanstha({
										...params,
										...exportFilters,
										hub: hubId || permissionOfHub,
										loading: false,
									}),
								)
							}
							columns={sansthaExportColumns}
							fileName="Sanstha"
							sheetName="Sanstha List"
							buttonText="Export Sanstha"
						/>

						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/sanstha/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Sanstha
						</button>
					</div>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default Sanstha
